import React from "react";
import { Link } from "./L";
import { Phone, Mail, ShieldCheck, MapPin, ChevronRight } from "lucide-react";
import { cities, contactInfo, cityLabel, LOGO } from "../mock";
import { useLang } from "../context/LanguageContext";

const Footer = () => {
  const { lang, t } = useLang();
  return (
    <footer className="bg-[#12211b] text-slate-300">
      <div className="max-w-[1200px] mx-auto px-5 md:px-6 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="mb-4">
              <img src={LOGO} alt="MyCleaner.ch" className="h-8 w-auto brightness-0 invert opacity-90" />
            </div>
            <p className="text-sm leading-relaxed text-slate-400 mb-4">{t.footer.tagline}</p>
            <div className="flex items-center gap-2 text-teal-400 text-sm font-semibold"><ShieldCheck className="w-4 h-4" /> {t.footer.trust}</div>
          </div>

          <div>
            <h4 className="font-head font-semibold text-white text-sm mb-4">{t.footer.colCities}</h4>
            <ul className="space-y-2.5">
              {cities.slice(0, 8).map((c) => (
                <li key={c.slug}>
                  <Link to={`/putzfrau/${c.slug}`} className="text-sm text-slate-400 hover:text-teal-400 transition-colors">{t.term} {cityLabel(c, lang)}</Link>
                </li>
              ))}
              <li><Link to="/staedte" className="text-sm text-teal-400 font-medium hover:text-teal-300">{t.footer.allCities}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-head font-semibold text-white text-sm mb-4">{t.footer.colService}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/so-funktionierts" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">{t.footer.links.howItWorks}</Link></li>
              <li><Link to="/preise" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">{t.footer.links.pricing}</Link></li>
              <li><Link to="/ratgeber" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">{t.blog.eyebrow}</Link></li>
              <li><Link to="/buchen" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">{t.footer.links.book}</Link></li>
              <li><Link to="/putzfrau-werden" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">{t.footer.links.jobs}</Link></li>
              <li><Link to="/kontakt" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">{t.footer.links.contact}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-head font-semibold text-white text-sm mb-4">{t.footer.colContact}</h4>
            <ul className="space-y-3">
              <li><a href={contactInfo.phoneHref} className="flex items-center gap-2.5 text-sm text-slate-400 hover:text-teal-400"><Phone className="w-4 h-4 text-teal-400" /> {contactInfo.phone}</a></li>
              <li><a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2.5 text-sm text-slate-400 hover:text-teal-400"><Mail className="w-4 h-4 text-teal-400" /> {contactInfo.email}</a></li>
              <li className="flex items-center gap-2.5 text-sm text-slate-400"><MapPin className="w-4 h-4 text-teal-400" /> {t.footer.region}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} MyCleaner.ch – {t.footer.rights}</p>
          <div className="flex flex-wrap justify-center items-center gap-4">
            <Link data-testid="footer-popular-link" to="/beliebte-suchen" className="text-xs text-slate-400 hover:text-teal-400">{lang === "de" ? "Beliebte Suchen" : "Popular searches"}</Link>
            <Link data-testid="footer-datenschutz-link" to="/datenschutz" className="text-xs text-slate-400 hover:text-teal-400">{lang === "de" ? "Datenschutz" : "Privacy"}</Link>
            <Link data-testid="footer-agb-link" to="/agb" className="text-xs text-slate-400 hover:text-teal-400">{lang === "de" ? "AGB" : "Terms"}</Link>
            <Link data-testid="footer-impressum-link" to="/impressum" className="text-xs text-slate-400 hover:text-teal-400">Impressum</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
